import React, { Children } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div.attrs({ className: 'ui__list' })`
  list-style: none;
  padding: 0;
  margin: ${(props) => props.theme.whitespace.large} 0;
  border-top: ${(props) => props.theme.borders.default};
  border-bottom: ${(props) => props.theme.borders.default};
  overflow: hidden;
`;
const WrappedChild = styled.div`
  margin: ${(props) => props.theme.gutters.horizontal} 0;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;
function wrapChild(child) {
  return child ? <WrappedChild>{child}</WrappedChild> : null;
}

const List = ({ children, gutters, ...props }) => (
  <Container {...props}>
    {gutters ? Children.map(children, (child) => wrapChild(child)) : children}
  </Container>
);
List.propTypes = {
  children: PropTypes.node,
  gutters: PropTypes.bool
};
List.defaultProps = {
  children: null,
  gutters: false
};
export default List;
